import {Action} from 'redux-act';
import {select, call, take, takeEvery} from 'redux-saga/effects';
import {
    createAddToWishlistEvent,
    createRemoveFromWishlistEvent,
} from '@optimaxdev/analytics/mobile';
import {sendWishListAnalytics} from 'sagas/EEC/wishlist/helpers';

import {setWishlistIds, getWishlistIds} from 'reducers/wishlist/wishlist';
import {MYPICKS} from 'constants/actions';

type HandleWishListPropsType = {
    productSku: string;
    source: string;
};

/**
 * Processing the update of the wishlist
 */
export function* handleWishlistAction({
    payload: {productSku, source},
}: Action<HandleWishListPropsType>) {
    const currentWishlistIds = yield select(getWishlistIds);
    yield take(setWishlistIds);
    const updatedWishlistIds = yield select(getWishlistIds);
    if (currentWishlistIds.length === updatedWishlistIds.length) return;
    yield call(
        sendWishListAnalytics,
        productSku,
        source,
        currentWishlistIds.length > updatedWishlistIds.length
            ? createRemoveFromWishlistEvent
            : createAddToWishlistEvent,
    );
}

/**
 * Root saga for wishlist
 */
export default function* wishlistSaga() {
    yield takeEvery(MYPICKS.TOGGLE, handleWishlistAction);
}
